import React, { useEffect, useContext, useState } from 'react';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { Link, useNavigate, useParams } from 'react-router-dom';
import Common from '../../Common/Common';
import PartService from '../Controller/PartController';
import CreatePartMobile from "./PartForms/CreatePartMobile";
function JobsDetailMobile() {
    const navigate = useNavigate();
    const StockID = localStorage.getItem("StockID");
    const { theme } = useContext(ThemeContext);
    const [partName, setPartName] = useState("New Part");
    const [activeTab, setActiveTab] = useState(null); // Initially, no tab is active (only tabs will be shown)
    const [currentStockID, setCurrentStockID] = useState(localStorage.getItem("StockID"));
    const [showTabs, setShowTabs] = useState(true); // Initially, only tabs are visible

    useEffect(() => {
        setCurrentStockID(StockID);
        if (StockID > 0) {
            fetchPartDetail(StockID);
        } else {
            setPartName("New Stock");
        }
    }, [StockID]);

    const fetchPartDetail = async (newStockID) => {
        try {
            if (newStockID > 0) {
                const partDetail = await PartService.GetPartByID(navigate, newStockID);
                setPartName(`Stock Code. ${partDetail[0].vc_StockCode}`);
            }
        }
        catch (error) {
            alert(error);
        }
    };

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setShowTabs(false); // Hide tabs and show content
    };

    const handleBackToTabs = () => {
        setActiveTab(null); // Hide content
        setShowTabs(true); // Show tabs
    };

    return (

        <div className="container-fluid p-0">

            <Common />

            <div className="modal-header text-white text-center py-3 d-flex align-items-center justify-content-between px-3">
                {activeTab && (
                    <button onClick={handleBackToTabs} className="btn btn-secondary m-2">Back</button>

                )}
                <h5 className="m-0 flex-grow-1 text-center modal-title">{partName}</h5>
                <Link to="/PartsListMobile" className="btn btn-secondary m-2">Parts</Link>
            </div>
            {showTabs ? (
                <div className="list-group m-2">

                    <button className="list-group-item d-flex justify-content-between align-items-center" onClick={() => handleTabClick("createPart")}>
                        Part <span className="text-muted">View</span>
                    </button>                 
                 
                </div>
            ) : (
                activeTab === "createPart" ? (
                    <CreatePartMobile
                        StockID={currentStockID}
                        onSuccess={handleBackToTabs}
                        onBack={handleBackToTabs}
                    />
                )  : (
                    <button onClick={handleBackToTabs} className="btn btn-secondary m-2">Back</button>
                )
            )}

        </div>
    );
}

export default JobsDetailMobile;
